export { default as LoyaltyTiersWidget } from './loyalty-tiers-widget';
